import Vue from 'vue';
import axios from 'axios';
import helpers from '@/mixins/helpers';
import store from '@/store';
import { DialogProgrammatic as Dialog } from 'buefy';

axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;

/*
 * The member's token (docs/16-api-authorization.md) goes with every call. A 401 on a call that
 * carried one means the sign-in has run out or was withdrawn: the member is signed out and
 * sent to sign in again. A 401 without a token - a wrong password on the sign-in itself - is
 * left to the caller.
 */
let signingOut = false;

export function signOutExpired(message) {
	store.commit('logout');
	if (signingOut) {
		return;
	}
	signingOut = true;
	const lang = (Vue.prototype.$lang && Vue.prototype.$lang.Login) || {};
	Dialog.alert({
		title: lang.SessionEndedTitle || 'Oturum sona erdi',
		// The dictionary's text first: the API's is Turkish only.
		message: lang.SessionEndedMsg || message || 'Lütfen tekrar giriş yapın.',
		confirmText: lang.SessionEndedOk || 'Tamam',
		type: 'is-danger',
		hasIcon: true,
		onConfirm: () => {
			signingOut = false;
			window.location = '/loginMember';
		}
	});
}

axios.interceptors.response.use(
	function (response) {
		if (response.status == 200) {
			helpers.methods.handleDates(response.data);
		}

		return response;
	},
	function (error) {
		const sentToken = error.config && error.config.headers && error.config.headers.Authorization;
		if (error.response && error.response.status == 401 && sentToken) {
			signOutExpired(error.response.data && error.response.data.error_description);
		}

		return Promise.reject(error);
	}
);

axios.interceptors.request.use(
	function (request) {
		helpers.methods.replaceDates(request.data);

		if (store.state.token) {
			request.headers.Authorization = 'Bearer ' + store.state.token;
		}
		if (store.state.guestKey) {
			request.headers['X-Guest-Key'] = store.state.guestKey;
		}

		return request;
	},
	function (error) {
		return Promise.reject(error);
	}
);

export { axios };

export function getClientId() {
	return process.env.VUE_APP_API_CLIENTID;
}

export function getToken() {
	return store.state.token;
}
